import apartone from "../../assets/img/apartone.png";
import aparttwo from "../../assets/img/aparttwo.png";
import apartthree from "../../assets/img/apartthree.png";
import apartfour from "../../assets/img/apartfour.png";
import apartfive from "../../assets/img/apartfive.png";
import apartsix from "../../assets/img/apartsix.png";
import Shake from "react-reveal/Shake";
import AOS from "aos";
import { useEffect } from "react";

const WhatSetsUsApart = () => {
  useEffect(() => {
    AOS.refresh();
  }, []);
  const features = [
    {
      title: "Simple, Flexible Learning for Every Child",
      image: apartone,
    },
    {
      title: "Supportive Environment Kids Can Thrive In",
      image: aparttwo,
    },
    {
      title: "Easy and Fun for Absolute Beginners",
      image: apartthree,
    },
    {
      title: "Great Value Without Breaking the Bank",
      image: apartfour,
    },
    {
      title: "Practical Curriculum for Real-World Impacts",
      image: apartfive,
    },
    {
      title: "Expert Tutors Who Make Tech Exciting",
      image: apartsix,
    },
  ];

  return (
    <section className="py-16 px-5 md:px-10 lg:px-32 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <Shake>
            <h2 className="text-3xl md:text-4xl lg:text-4xl font-DM_SANS font-bold text-[#1B1B1B]">
              What Sets Us <span className="text-[#FF4B01]">Apart?</span>
            </h2>
          </Shake>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              data-aos="fade-down-left"
              data-aos-duration="2000"
              key={index}
              className="bg-white px-8 pt-8 pb-4 text-center transition-shadow duration-300 relative overflow-hidden"
              style={{
                boxShadow:
                  "-3px -3px 12px rgba(0, 0, 0, 0.06), -1px -1px 4px rgba(0, 0, 0, 0.03)",

                backgroundSize: "20px 20px",
                backgroundPosition: "0 0, 10px 10px",
              }}
            >
              {/* Content */}
              <div className="relative z-10">
                <div className="w-52 h-52 mx-auto mb-6">
                  <img
                    src={feature.image || "/placeholder.svg"}
                    alt={feature.title}
                    className="w-full h-full object-contain"
                  />
                </div>
                <div className="justify-center items-center flex">
                  <h3 className="font-DM_SANS font-normal w-44 text-lg text-[#475569B2]/70 leading-tight">
                    {feature.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatSetsUsApart;

// import apartone from "../../assets/img/apartone.png";
// import aparttwo from "../../assets/img/aparttwo.png";
// import apartthree from "../../assets/img/apartthree.png";
// import apartfour from "../../assets/img/apartfour.png";
// import apartfive from "../../assets/img/apartfive.png";
// import apartsix from "../../assets/img/apartsix.png";

// const WhatSetsUsApart = () => {
//   const features = [
//     {
//       title: "Simple, Flexible Learning for Every Child",
//       image: apartone,
//     },
//     {
//       title: "Supportive Environment Kids Can Thrive In",
//       image: aparttwo,
//     },
//     {
//       title: "Easy and Fun for Absolute Beginners",
//       image: apartthree,
//     },
//     {
//       title: "Great Value Without Breaking the Bank",
//       image: apartfour,
//     },
//     {
//       title: "Practical Curriculum for Real-World Impacts",
//       image: apartfive,
//     },
//     {
//       title: "Expert Tutors Who Make Tech Exciting",
//       image: apartsix,
//     },
//   ];

//   return (
//     <section className="py-16 px-5 md:px-10 lg:px-32 bg-white">
//       <div className="max-w-7xl mx-auto">
//         <div className="text-center mb-12">
//           <h2 className="text-3xl md:text-4xl lg:text-4xl font-DM_SANS font-bold text-[#1B1B1B]">
//             What Sets Us <span className="text-[#FF4B01]">Apart?</span>
//           </h2>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//           {features.map((feature, index) => (
//             <div
//               key={index}
//               className="bg-white p-8 text-center shadow-lg transition-shadow duration-300"
//             >
//               <div className="w-52 h-52 mx-auto mb-6">
//                 <img
//                   src={feature.image}
//                   alt={feature.title}
//                   className="w-full h-full object-contain"
//                 />
//               </div>
//               <div className=" justify-center items-center flex ">
//                 <h3 className=" font-DM_SANS font-normal w-44 text-lg text-[#475569B2]/70 leading-tight">
//                   {feature.title}
//                 </h3>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhatSetsUsApart;
